import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoad: false,
    main: {},
    fleet: {},
    currentPage: '',
    deviceSize: {
      width: 320,
      height: 480
    }
  },
  getters: {
    isMobile: state => state.deviceSize.width < 768,
    isTablet: state => state.deviceSize.width >= 768 && state.deviceSize.width < 1280,
    isDesktop: state => state.deviceSize.width >= 1280
  },
  mutations: {
    setGeneralData (state, newGeneralData) {
      state.main = newGeneralData
    },
    setFleetPageData (state, newFleetPageData) {
      state.fleet = newFleetPageData
    },
    setDeviceWidth (state, width) {
      state.deviceSize.width = width
    },
    setIsLoad (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = state.main.title || state.fleet.title || 'no title'
      state.isLoad = true
    },
    setIsLoadFleet (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = state.fleet.title || 'no title'
      state.isLoad = true
    },
    setDeviceHeight (state, height) {
      state.deviceSize.height = height
    }
  }
})
